export default __webpack_public_path__ + "static/006-34697ae6e4a1ab2083a8b98fe6430fb7.jpg";